import { render, staticRenderFns } from "./AiContextGroupsTable.vue?vue&type=template&id=94327872&scoped=true"
import script from "./AiContextGroupsTable.vue?vue&type=script&lang=js"
export * from "./AiContextGroupsTable.vue?vue&type=script&lang=js"
import style0 from "./AiContextGroupsTable.vue?vue&type=style&index=0&id=94327872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94327872",
  null
  
)

export default component.exports